import React from "react";
import "./style.scss";

const CheckboxContainer = ({ children, className }) => {
  return <div className={`checkbox-container ${className}`}>{children}</div>;
};

export default CheckboxContainer;
